import { Box } from '@mui/material'
import { useParams } from 'react-router-dom';
import GeneratedReportService from '../../../shared/services/generated-report/generatedReport.service';
import { useContext, useEffect, useState } from 'react';
import { UserNotificationsContext } from '../../../context/user-notifications/user-notifications';
import { IGaiaReportWebpageReport } from '../../../modules/public-reports/shared-services/public-reports.model';
import { GaiaReportWebPage } from '../../../modules/public-reports/components/gaia-report-web-page';

export const ReportingWebPage = () => {

  const { reportType, id } = useParams();
  //Services
  const generatedReportService = new GeneratedReportService()
  //Context
  const userNotificationsContext = useContext(UserNotificationsContext)
  //State
  const [report, setReport] = useState<IGaiaReportWebpageReport>()

  useEffect(() => {
    if (reportType && id) {
      generatedReportService.getWebpage(reportType, id)
        .then(response => {
          setReport(response)
        })
        .catch(err => {
          console.log(err)
          if (err.response.data.code === 1) {
            userNotificationsContext.openDialog({
              active: true, title: 'Action Not Allowed',
              message: `You cannot generate a webpage while the reporting period is still open.`,
              buttonCopy: 'Ok',
              hideCancelButton: true
            })
          }
        })
    }
  }, [reportType, id])

  return (
    <Box style={{ width: '100%', height: '100%' }}>
      {report && < GaiaReportWebPage report={report} />}
    </Box>
  )
}